import { useQuery } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { baseURL } from "@/Environment";
import { QUERY_KEYS } from "./querykeys";
import { AxiosResponseAndError, ResponseType } from "../types/axiosResponseType";

export interface ProjectBaselineItemData {
  id: string;
  taskId: string;
  parentTaskId: string | null;
  taskName: string;
  startDate: string;
  endDate: string;
  duration: number;
  lastKnownProgress: number;
}

export interface ProjectBaselineData {
  id: string;
  projectId: string;
  organisationId: string;
  savedAt: string;
  savedByUserId: string;
  baselineStartDate: string;
  baselineEndDate: string;
  baselineDuration: number;
  calendarSnapshot?: {
    nonWorkingDays?: string[];
    holidays?: Array<{ date: string; name?: string }>;
  };
  savedByUser?: {
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string;
  };
  items: ProjectBaselineItemData[];
}

export type ProjectBaselineResponseType = ResponseType<ProjectBaselineData | null>;

export const useProjectBaselineQuery = (projectId: string | undefined) => {
  return useQuery<
    AxiosResponseAndError<ProjectBaselineResponseType>["response"],
    AxiosResponseAndError<ProjectBaselineResponseType>["error"]
  >({
    queryKey: [QUERY_KEYS.projectBaseline, projectId],
    queryFn: async () =>
      await ApiRequest.get(`${baseURL}/api/project/${projectId}/baseline`),
    enabled: Boolean(projectId),
    refetchOnWindowFocus: false,
  });
};

export default useProjectBaselineQuery;